import { Control, Controller } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import i18n from 'i18n';
import { FormLabel } from '../../form-label';
import LOCALS from 'commons/locals';
import { Input } from 'antd';

const FakeBagReason = ({
  control,
  index,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
}) => {
  return (
    <div className="flex items-start gap-2">
      <FormLabel required className="self-start">
        {i18n.t(LOCALS.reason_for_rejection)}:
      </FormLabel>
      <Controller
        name={`productList.${index}.fakeBagReason`}
        control={control}
        render={({ field, fieldState }) => (
          <div className="flex flex-col gap-1 flex-1">
            <Input.TextArea
              {...field}
              maxLength={200}
              placeholder={i18n.t(LOCALS.reason_for_rejection) || ''}
              showCount
            />
            {fieldState.error?.message && (
              <div className="text-xs text-red-500 leading-5">
                {fieldState.error.message}
              </div>
            )}
          </div>
        )}
      />
    </div>
  );
};

export default FakeBagReason;